import { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import * as styles from "./Paragraph.css";
import clsx from "clsx";

export type ParagraphProps = ComponentPropsWithoutRef<"div"> &
  styles.ParagraphVariants &
  PropsWithChildren & { as?: "div" | "p" };

export const Paragraph = ({
  size,
  bold,
  children,
  className,
  as = "p",
  ...props
}: ParagraphProps) => {
  const Component = as;
  return (
    <Component className={clsx(className, styles.paragraph({ size, bold }))} {...props}>
      {children}
    </Component>
  );
};
